import { useDisclosure } from "@mantine/hooks";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import axios from "axios";
import base_url from "../../api/bootapi";
import PhoneInput from "react-phone-number-input";
import { Loader, Menu, Modal } from "@mantine/core";

import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";

const FlightItem = ({
  flight,
  setShowDetails,
  adults,
  children,
  InfantsInSeat,
  InfantsOnLap,
  handleMinus,
  handlePlus,
  selectedMultiCityFlights,
  setSelectedMultiCityFlights,
  setPreviousFlight,
  previousFlight,
  multiCity,
  setFlightDetailsData,
  expand = false,
  hideSelectBtn = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(expand);
  const [totalTravellers, setTotalTravellers] = useState(0);
  const [opened, { open, close }] = useDisclosure(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const tripType = flight.type;
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    const total = adults + children + InfantsInSeat + InfantsOnLap;
    setTotalTravellers(total);
  }, [adults, children, InfantsInSeat, InfantsOnLap]);

  const dayDateFormatChange = (dateStr) => {
    const date = new Date(dateStr);

    const weekday = date.toLocaleString("en-US", { weekday: "short" }); // Mon
    const month = date.toLocaleString("en-US", { month: "short" }); // Jul
    const day = date.getDate(); // 28
    const time = date.toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Step 4: Combine final output
    const finalOutput = `${weekday}, ${month} ${day} . ${time}`;

    return finalOutput;
  };

  const onSubmit = async (data) => {
    setLoadingRequest(true);
    setIsSuccess(false);
    const personalDetails = data;
    personalDetails.adults = adults;
    personalDetails.children = children;
    personalDetails.infants_in_seat = InfantsInSeat;
    personalDetails.infants_on_lap = InfantsOnLap;
    personalDetails.travelers =
      adults + children + InfantsInSeat + InfantsOnLap;

    if (previousFlight) {
      const flightsArray = flight.flights;
      const previousFlightsArray = previousFlight.flights;
      flight.flights = [...previousFlightsArray, ...flightsArray];
    }

    if (selectedMultiCityFlights.length > 0) {
      const flightsArray = flight.flights;
      const multiCityFlightsArray = selectedMultiCityFlights.map(
        (flightItem) => {
          return flightItem.flights;
        }
      );
      const flatArray = multiCityFlightsArray.flat();
      flight.flights = [...flatArray, ...flightsArray];
    }
    const requestData = flight;
    requestData.person = personalDetails;

    try {
      const response = await axios.post(
        `${base_url.api1}/users/save_booking_enquiry`,
        requestData
      );
      console.log(response.data);

      setLoadingRequest(false);
      reset();
      setIsSuccess(true);
    } catch (error) {
      setLoadingRequest(false);
      setIsSuccess(false);
    }
  };

  const flightList = flight.flights;
  const layovers = flight.layovers || [];
  const flightsListLength = flightList.length;
  let flightFirstAirportCode = flightList[0].departure_airport.id;
  let flightLastAirportCode =
    flightList[flightsListLength - 1].arrival_airport.id;

  const price = flight?.price || null;
  const type = flight?.type || null;
  const airlineLogo = flight?.airline_logo || null;

  const getTotalDuration = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours} hr ${minutes} min`;
  };

  const convertTo12Hour = (time24) => {
    const [hours, minutes] = time24.split(":");
    const date = new Date();
    date.setHours(+hours);
    date.setMinutes(+minutes);

    return date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  const modifiedFlightList = flightList.map((flight) => {
    const layoverMatch = layovers.find(
      (layover) => layover.id === flight.arrival_airport.id
    );
    if (layoverMatch) {
      return {
        ...flight,
        layover: layoverMatch,
      };
    }
    return flight;
  });

  useEffect(() => {
    setHeight(isExpanded ? `${contentRef.current.scrollHeight + 50}px` : "0px");
  }, [isExpanded]);

  let totalDays = 0;

  if (flightList.length > 0) {
    const parseDate = (str) => new Date(str.replace(" ", "T"));

    const start = parseDate(flightList[0].departure_airport.time);
    const end = parseDate(
      flightList[flightList.length - 1].arrival_airport.time
    );

    if (end > start) {
      const startDay = start.getDate();
      const endDay = end.getDate();

      const startMonth = start.getMonth();
      const endMonth = end.getMonth();

      const startYear = start.getFullYear();
      const endYear = end.getFullYear();

      // Convert dates to pure "YYYY-MM-DD" for accurate day difference
      const startOnly = new Date(startYear, startMonth, startDay);
      const endOnly = new Date(endYear, endMonth, endDay);

      const diffInMs = endOnly - startOnly;
      totalDays = diffInMs / (1000 * 60 * 60 * 24); // pure date difference
    }
  }

  const departureTime = convertTo12Hour(
    flightList[0].departure_airport.time.split(" ")[1]
  );
  const arrivalTime = convertTo12Hour(
    flightList[flightsListLength - 1].arrival_airport.time.split(" ")[1]
  );

  return (
    <div
      className={`indivisual-flight-item-wrapper ${isExpanded && "is-expand"}`}
    >
      <div
        className="flight-item-wrapper-top"
        style={{
          borderBottom: isExpanded
            ? "1px solid #2222229a"
            : "1px solid transparent",
        }}
      >
        <div className="flight-icon-details-wrapper">
          <img alt="flight-icon" src={airlineLogo} />
          <div className="flight-details">
            <div className="flight-time">
              {departureTime}
              <RemoveIcon fontSize="13px" /> {arrivalTime}
              {totalDays > 0 && (
                <span className="total-days">+{totalDays}</span>
              )}
            </div>
            <div className="flight-name">
              {flightList && flightList.length > 1
                ? flightList.map((flight, index) => {
                    return (
                      flight.airline +
                      (index !== flightList.length - 1 ? ", " : "")
                    );
                  })
                : flightList[0]?.airplane + " . " + flightList[0]?.airline}
            </div>

            <div className="flight-name-mobile">
              {getTotalDuration(flight?.total_duration)},{" "}
              <span className="flight-code">
                {flightFirstAirportCode}
                <RemoveIcon fontSize="4px" />
                {flightLastAirportCode}
              </span>
              ,
              {layovers && layovers.length > 0 ? (
                <>{" " + layovers.length + " stops"}</>
              ) : (
                "Nonstops"
              )}
              {/* , {type} */}
            </div>
          </div>
        </div>

        <div className="flight-duration-wrapper">
          <span className="flight-duration-new">
            {getTotalDuration(flight?.total_duration)}
          </span>
          <span className="flight-code">
            {flightFirstAirportCode}
            <RemoveIcon fontSize="4px" />
            {flightLastAirportCode}
          </span>
        </div>

        <div className="flight-stops-wrapper">
          <span className="flight-stops">
            {layovers && layovers.length > 0 ? (
              <>
                {layovers.length + " stops"}
                <span className="flight-code">
                  {layovers.map((layover, index) => {
                    return (
                      layover.id + (index !== layovers.length - 1 ? ", " : "")
                    );
                  })}
                </span>
              </>
            ) : (
              "Nonstops"
            )}
          </span>
        </div>

        <div className="flight-price-wrapper">
          {/* {price && (
              <span className="new-flight-price">
                {currencySymbol}
                {price}
              </span>
            )} */}
          <span className="trip-name">{type}</span>
        </div>

        {/* <div className="submit-btn-wrapper">
          {tripType === "One way" ||
          (tripType === "Round trip" && previousFlight) ||
          (tripType === "Multi-city" &&
            multiCity.length === selectedMultiCityFlights.length + 1) ? (
            <span className="submit-request-btn" onClick={open}>
              <EmailOutlinedIcon sx={{ fontSize: "17px" }} />
              <span> Submit request</span>
            </span>
          ) : (
            <span
              className="submit-request-btn"
              onClick={() => {
                console.log("Calling ========> ");
                if (tripType === "Round trip") {
                  console.log("Calling ========> Round");

                  setPreviousFlight(flight);
                }

                if (tripType === "Multi-city") {
                  setSelectedMultiCityFlights((prev) => [...prev, flight]);
                }
              }}
            >
              <FlightOutlinedIcon sx={{ fontSize: "17px" }} />
              <span>Select flight</span>{" "}
            </span>
          )}
              </div> */}

        {!hideSelectBtn && (
          <div className="submit-btn-wrapper">
            <span
              className="submit-request-btn"
              onClick={() => {
                if (tripType === "Round trip") {
                  if (previousFlight) {
                    //execute
                    setFlightDetailsData([previousFlight, flight]);
                    setShowDetails(true);
                  } else {
                    setPreviousFlight(flight);
                  }
                } else if (tripType === "One way") {
                  //execute
                  setFlightDetailsData([flight]);
                  setShowDetails(true);
                } else if (tripType === "Multi-city") {
                  if (
                    multiCity.length ===
                    selectedMultiCityFlights.length + 1
                  ) {
                    setFlightDetailsData([...selectedMultiCityFlights, flight]);
                    setShowDetails(true);
                  } else {
                    setSelectedMultiCityFlights((prev) => [...prev, flight]);
                  }
                }
              }}
            >
              <FlightOutlinedIcon sx={{ fontSize: "17px" }} />
              <span>Select flight</span>{" "}
            </span>
          </div>
        )}

        <div>
          <span
            className={`expand-btn ${isExpanded && "rotate"}`}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <ExpandMoreIcon />
          </span>
        </div>
      </div>
      <div
        ref={contentRef}
        style={{
          maxHeight: height,

          overflow: "hidden",
          transition: "max-height 0.3s ease",
        }}
      >
        {modifiedFlightList &&
          modifiedFlightList.length > 0 &&
          modifiedFlightList.map((flightItem, index) => {
            return (
              <div key={index}>
                <div className="flight-desc">
                  <div className="flight-desc-left">
                    <div className="flight-jouney-details">
                      <img
                        alt="flight-icon"
                        src={flightItem.airline_logo}
                        style={{
                          visibility:
                            flightList.length > 1 ? "visible" : "hidden",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "stretch",
                          gap: "10px",
                        }}
                      >
                        <div className="dot-wrapper">
                          <span className="dot"></span>
                          <span className="dots"></span>
                          <span className="dot"></span>
                        </div>
                        <div className="flight-journey-place">
                          <span className="time-with-airport">
                            {dayDateFormatChange(
                              flightItem.departure_airport.time
                            )}{" "}
                            . {flightItem.departure_airport?.name} (
                            {flightItem.departure_airport?.id})
                          </span>
                          <span className="travel-time">
                            Travel time:{" "}
                            {getTotalDuration(flightItem?.duration)}
                            {flightItem.overnight && (
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  paddingLeft: "5px",
                                }}
                              >
                                {" . "}
                                Overnight{" "}
                                <ReportProblemOutlinedIcon
                                  sx={{ fontSize: "16px", color: "#f28b82" }}
                                />
                              </span>
                            )}
                          </span>

                          <span className="time-with-airport">
                            {dayDateFormatChange(
                              flightItem.arrival_airport.time
                            )}{" "}
                            . {flightItem.arrival_airport?.name} (
                            {flightItem.arrival_airport?.id})
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="layover-wrapper">
                      <div className="flight-jouney-class">
                        {flightItem?.airline} . {flightItem?.travel_class} .{" "}
                        {flightItem?.airplane} . {flightItem?.flight_number}
                      </div>
                    </div>
                  </div>

                  <div className="flight-desc-right">
                    {flightItem.extensions &&
                      flightItem.extensions.map((extension, index) => {
                        return <span key={index}>{extension}</span>;
                      })}
                  </div>
                </div>
                {flightItem.layover && (
                  <div className="layover-item">
                    {getTotalDuration(flightItem.layover.duration)} layover .{" "}
                    {flightItem.layover.name}({flightItem.layover.id}){" "}
                    {flightItem.layover.overnight && (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingLeft: "3px",
                        }}
                      >
                        {" . "}
                        Overnight layover{" "}
                        <ReportProblemOutlinedIcon
                          sx={{ fontSize: "16px", color: "#f28b82" }}
                        />
                      </span>
                    )}
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default FlightItem;
